import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { openCookiePreferences } from '@/lib/cookieConsent';

export function PublicFooter() {
  return (
    <footer className="border-t bg-background">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 pt-14 pb-10">

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 mb-10">

          {/* Marca — mesmo ícone do header (/icon.png); logo_eventfy.png é a
              logomarca completa (ícone + wordmark + tagline) com bastante
              respiro em volta, então a ~28px vira um blob ilegível — foi
              isso que parecia "imagem quebrada". */}
          <div className="sm:col-span-2 md:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <img
                src="/icon.png"
                alt=""
                className="h-9 w-auto object-contain"
              />
              <span className="text-lg font-bold text-foreground">Joyn</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Os melhores eventos de Joinville em um só lugar.
            </p>
          </div>

          {/* Explorar */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Explorar</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/" className="hover:text-foreground transition-colors">
                  Eventos
                </Link>
              </li>
              <li>
                <Link to="/busca" className="hover:text-foreground transition-colors">
                  Buscar
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Legal</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/privacy" className="hover:text-foreground transition-colors">
                  Privacidade
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-foreground transition-colors">
                  Termos de uso
                </Link>
              </li>
              <li>
                <Link to="/child-safety" className="hover:text-foreground transition-colors">
                  Segurança infantil
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openCookiePreferences}
                  className="hover:text-foreground transition-colors text-left"
                >
                  Preferências de cookies
                </button>
              </li>
            </ul>
          </div>

          {/* Organizadores */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Organizadores</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/login" className="hover:text-foreground transition-colors">
                  Painel do organizador
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <Separator />

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Joyn. Todos os direitos reservados.</span>
          <span>Joinville, Santa Catarina</span>
        </div>

      </div>
    </footer>
  );
}
